// extracted by mini-css-extract-plugin
export default {"countdown":"countdown--RMYsx","timefield":"timefield--_jp3s","digit":"digit--J3HCW","label":"label--I9P0R"};